import RenderChart from '../../../component/RenderData/RenderChart';
import lineChartDataOption from "./PredictiveLineChartData";

function FounlingMetrics() {
  return (
    <RenderChart
      chartOptions={lineChartDataOption}
      chartTitle="Fouling Metrics"
      dropdownOptions={['cc_flvl']}
  />
  );
}
export default FounlingMetrics;
